import axios, { AxiosError } from "axios";
import { API_URL, DemographicsData, VerifyResult} from "../constant";

export async function api_updateDemographic(data: DemographicsData): Promise<VerifyResult>  {
    const token = localStorage.getItem("token")
        
    const config = {
        headers: {
          Authorization: `Bearer ${token}`, // Bearer token
        },
      };

    try {
        const response = await axios.post(
          `${API_URL}api/user/updateDemographic`,
          data,
          config,
        );
    
        if (response.status === 204)
        {
            return { bSuccess: true, msg: "Success to update"};
        }
        else if (response.status === 422)
        {
            return { bSuccess: false, msg: "Validation Error" };
        }
        else{
            return { bSuccess: false, msg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { bSuccess: false, msg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { bSuccess: false, msg: "No response received from server" };
        } else {
            return { bSuccess: false, msg: `Error:, ${error.message}` };
        }
    }
}